/**
 * Client wrapper for the server-side script AI. The API key never reaches the
 * browser — the server holds it and returns text the caller reviews before applying.
 */
export type ScriptAiMode = 'draft' | 'improve' | 'segment';

export interface ScriptAiInput {
  mode: ScriptAiMode;
  brief?: string;
  script?: string;
  targetSeconds?: number;
  instructions?: string;
}

export interface ScriptAiResult {
  provider: 'anthropic' | 'mock';
  mode: ScriptAiMode;
  text: string;
  sample: boolean;
}

export async function generateScript(input: ScriptAiInput): Promise<ScriptAiResult> {
  const res = await fetch('/api/ai/script', {
    method: 'POST',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data as { error?: string }).error ?? 'AI request failed');
  return data as ScriptAiResult;
}
